<template>
  <div>
    <transition :name="transitionName">
      <div class="c-cart-box" v-if="isOpened" @mouseover="hover" @mouseleave="leave">
        <div class="c-cart-box__overlay" v-if="isDisabled">
          <div class="lds-ring lds-ring--green"><div></div><div></div><div></div><div></div></div>
        </div>
        <h3 class="c-cart-box__head t-head t-head--middle"><strong>Twój koszyk</strong></h3>

        <button type="button" class="c-cart-box__close c-btn c-btn--theme-10 c-btn--circle" @click="toggle">
            <span class="c-btn__wrap">
              <span class="o-ico o-ico--cancel o-ico--m">
                <svg><use xlink:href="#ico-cancel"></use></svg>
              </span>
            </span>
        </button>

        <BlockCartInfo v-if="products.length == 0">
          <!-- <template v-if="products.length > 0">
            <strong>Nie zwlekaj z zakupem.</strong> Dodanie artykułów do koszyka nie oznacza ich rezerwacji.
          </template> -->
          <template>
            <strong>Pusto tutaj... Wrzucisz coś?</strong>
          </template>
        </BlockCartInfo>

        <BlockCartList
          @deleteProduct="deleteProduct"
          @updateQuantity="updateQuantity"
          @hideProductsLogin="hideProductsLogin"
          :counterDisabled="isDisabled"
          :products="products"
          :productTotal="this.productTotal"
          :shippingCost="this.shippingCost"
          v-if="products.length > 0"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { BlockCartConfig, trinyConfig } from '@/config'
import BlockCartInfo from './BlockCartInfo.vue'
import BlockCartList from './BlockCartList.vue'
import BlockCartSummary from './BlockCartSummary.vue'
import BlockCartActions from './BlockCartActions.vue'
import { bindClickEvent, bindHoverEvent, addCssClass, removeCssClass, toggleCssClass, breakpointsMatches } from '@/shared'
// import ajaxCart from '@/shared/ajax-cart'

const $html = document.querySelector('html')
const $body = document.querySelector('body')
const $bodyWrapper = document.querySelector('#body_wrapper')
const $overlay = document.querySelector('.js-overlay')

let scrollPosition = 0

let timer

export default {
  components: {
    BlockCartInfo,
    BlockCartList,
    BlockCartSummary,
    BlockCartActions
  },

  data () {
    return {
      counterDisabled: false,
      isHovered: false,
      isOpened: false,
      isFirst: false,
      isDisabled: false,
      linkOrder: BlockCartConfig.linkOrder,
      products: BlockCartConfig.products,
      shippingCost: BlockCartConfig.shippingCost,
      productTotal: BlockCartConfig.productTotal,
      total: BlockCartConfig.total,
      isLogged: trinyConfig.logged,
      transitionName: breakpointsMatches.mobileSmall.matches ? 'slide-fade' : 'fade'
    }
  },

  mounted () {
    if (breakpointsMatches.tablet.matches) {
      bindClickEvent(document, '.js-blockcart-trigger', (e) => {
        this.toggle()
      }, { preventDefault: true })
    } else {
      bindHoverEvent(document, '.js-blockcart-trigger', (e) => {
        this.hover()
      }, (e) => {
        this.leave()
      }, { preventDefault: true })
    }

    bindClickEvent(document, '.js-overlay', (e) => {
      this.toggle()
    }, { preventDefault: true })
  },

  methods: {
    deleteProduct (index) {
      const product = this.products[index] // get current product
      // var disable = setTimeout(() => {
      this.isDisabled = true
      // }, 100)
      ajaxCart.remove(product.id, product.idProductAttribute, 0, product.idAddressDelivery, () => { // eslint-disable-line
        var disable = setTimeout(() => {
          this.$delete(this.products, index) // delete from the list
        }, 1)
        this.isDisabled = false
        window.clearTimeout(disable)
      }, () => {
        this.isDisabled = false
        // window.clearTimeout(disable)
      })
    },

    updateQuantity ({ quantity, index, operator, current }) {
      const product = this.products[index] // get current product
      // var disable = setTimeout(() => {
      this.isDisabled = true
      // }, 100)
      if (operator === 'down') {
        ajaxCart.updateQuantity(product.id, product.idCombination, false, null, quantity, operator, () => { // eslint-disable-line
          this.isDisabled = false
          // window.clearTimeout(disable)
        }, () => {
          this.isDisabled = false
          // window.clearTimeout(disable)
        })
      } else if (operator === 'up') {
        ajaxCart.add(product.id, product.idCombination, false, null, quantity, null, () => { // eslint-disable-line
          this.isDisabled = false
          // window.clearTimeout(disable)
        }, () => {
          this.isDisabled = false
          // window.clearTimeout(disable)
        })
      }
    },

    updateProducts (data) {
      this.products = data.products
      this.shippingCost = data.shippingCost
      this.total = data.total
      this.productTotal = data.productTotal
      setTimeout(function () {
        var lazyLoadInstance = new LazyLoad({ // eslint-disable-line
          elements_selector: '.lazy-picture',
          callback_error: function (image) {
            var imageParent = image.parentNode
            var imageSrc = image.getAttribute('src')

            image.parentNode.innerHTML = ''

            var fallbackImage = document.createElement('img')
            fallbackImage.src = imageSrc
            fallbackImage.className = 'lazy-picture-fallback'

            imageParent.appendChild(fallbackImage)
          }
        })
      }, 50)
    },

    showProducts () {
      this.isOpened = true
      removeCssClass($overlay, 'is-hidden')
      setTimeout(function () {
        var lazyLoadInstance = new LazyLoad({ // eslint-disable-line
          elements_selector: '.lazy-picture',
          callback_error: function (image) {
            var imageParent = image.parentNode
            var imageSrc = image.getAttribute('src')

            image.parentNode.innerHTML = ''

            var fallbackImage = document.createElement('img')
            fallbackImage.src = imageSrc
            fallbackImage.className = 'lazy-picture-fallback'

            imageParent.appendChild(fallbackImage)
          }
        })
      }, 50)
    },

    hideProducts () {
      this.isOpened = false
      addCssClass($overlay, 'is-hidden')
    },

    hideProductsLogin () {
      this.isOpened = false
    },

    toggle () {
      this.isOpened = !this.isOpened

      if (this.isOpened) {
        scrollPosition = window.scrollY
        $bodyWrapper.style.top = `-${scrollPosition}px`
      }
      toggleCssClass($overlay, 'is-hidden')
      if (!this.isOpened) {
        window.scrollTo(0, scrollPosition)
        $bodyWrapper.style.top = ''
      }
      if (window.innerWidth < 767) {
        toggleCssClass($html, 'cart-opened')
        toggleCssClass($body, 'cart-opened')
      }
      setTimeout(function () {
        var lazyLoadInstance = new LazyLoad({ // eslint-disable-line
          elements_selector: '.lazy-picture',
          callback_error: function (image) {
            var imageParent = image.parentNode
            var imageSrc = image.getAttribute('src')

            image.parentNode.innerHTML = ''

            var fallbackImage = document.createElement('img')
            fallbackImage.src = imageSrc
            fallbackImage.className = 'lazy-picture-fallback'

            imageParent.appendChild(fallbackImage)
          }
        })
      }, 50)
    },

    hover () {
      if (!breakpointsMatches.tablet.matches) {
        this.showProducts()
        this.isHovered = true
      }
    },

    leave () {
      if (!breakpointsMatches.tablet.matches) {
        this.isHovered = false

        clearTimeout(timer)
        timer = setTimeout((e) => {
          if (!this.isHovered) {
            this.hideProducts()
          }
        }, 50)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlockCart/BlockCart.vue